module.exports = __webpack_public_path__ + "static/media/5.ce5d207b.jpg";